import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  login;
  reset;
  showResetPwd = false;
  resetConfirm = false;
  show2FA = false;
  qrCodeImage: string;
  buttonText = 'Logg inn';

  constructor(
    public auth: AuthService,
    private router: Router
  ) { }

  ngOnInit() {

      this.login = new FormGroup({
        username: new FormControl('', Validators.required),
        password: new FormControl('', Validators.required),
        twofactorcode: new FormControl('')
      });

      this.reset = new FormGroup({
        username: new FormControl('', Validators.required)
      });

  }

logIn() {
  this.auth.authenticate(this.login.value.username, this.login.value.password, this.login.value.twofactorcode)
    .pipe(
      catchError((error) => {       
        if (error.status === 401) {
          if (error.error?.['2fa_setup_required'] || error.error?.['missing_2fa_code']) {
            if (!this.show2FA) {
              error.error['show2FAWasHidden'] = true;
            } else {
              error.error['show2FAWasHidden'] = false;
            }
            this.show2FA = true;
            this.buttonText = 'Fullfør innlogging med to-faktor kode';
            if (error.error?.['2fa_setup_required']) {
              this.qrCodeImage = error.error.setup_qr_image;
            } 
          }
        }
        return throwError(error);
      })
    )
    .subscribe(
      res => {
        this.router.navigate(['/']); // TODO: go to previous location
      },
      error => {
        if (error.status === 403 || error.error?.['wrong_2fa_code']) {      
          alert('Innlogging feilet: Ugyldig eller utløpt 2-faktor kode');
        } else {
          if (error.error?.['missing_2fa_code']) {
            if (!error.error['show2FAWasHidden']===true) {
              alert('Innlogging feilet: Mangler 2-faktor kode');
            }
          } else {
            alert('Innlogging feilet: Feil brukernavn eller passord');
          }
        }
      }
    );
}

  toggleReset() {
    this.showResetPwd = !this.showResetPwd;
    this.resetConfirm = false;
  }

  reloadPage() {
    window.location.reload();
  }

  resetPwd() {
    // TODO: generate email with user token if email adress is in system
    this.auth.resetPassword(this.reset.value.username)
      .subscribe( res => {
        if (res['result'] === 'OK') {
          this.resetConfirm = true;
        } else {
          alert('Klarte ikke sende reset passord email :(');
        }
      });
  }

}
